<template>
  <Section :id="id" class="search-builder">
    <div class="filters">
      <slot name="filters" />
    </div>

    <FilterSelect
      v-model="internalFilters"
      :possible-options="possibleFilterOptions"
      append-to="body"
    />
  </Section>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { DropdownOption } from '@rygen/rygen-ui/model';

import FilterSelect from '@rygen/rygen-ui/components/search/FilterSelect.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const internalFilters = defineModel('filters', {
  type: Object as PropType<Set<string>>,
  default: () => new Set<string>(),
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  possibleFilterOptions: {
    type: Array as PropType<Array<DropdownOption<string>>>,
    default: () => [],
  },
});
const { id, possibleFilterOptions } = toRefs(props);

defineSlots<{
  filters: () => any;
}>();
</script>

<style>
:root {
  --search-builder-filter-width: 215px;
}

.search-builder {
  padding: 0;

  .section-data {
    display: flex;
    gap: var(--sp-6);
    justify-content: space-between;
    min-width: 0;

    .filters {
      display: flex;
      gap: var(--gap-1);
      align-items: start;
      flex-wrap: wrap;
      min-width: 0;
      max-width: 100%;

      .input-wrapper {
        width: var(--search-builder-filter-width);

        .popup-inputgroup {
          .popup-inputgroup-card {
            width: max-content;
            top: calc((var(--sp-8) * -1) - 1px);
          }
        }
      }
    }
  }
}
</style>
